import React from 'react';

type Props = {
  className?: string;
};

/** Ícone decorativo: nós conectados + agente central (fluxo visual agêntico). */
export const AgentPlatformHubHeroIcon: React.FC<Props> = ({ className = 'h-32 w-32' }) => (
  <svg
    className={className}
    viewBox="0 0 120 120"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden
  >
    <path
      d="M24 60h18M78 60h18M60 24v14M60 82v14"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.45"
    />
    <path
      d="M42 60c0-9.941 8.059-18 18-18M78 60c0 9.941-8.059 18-18 18M60 38c9.941 0 18 8.059 18 18M60 82c-9.941 0-18-8.059-18-18"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.35"
    />
    <circle cx="24" cy="60" r="8" stroke="currentColor" strokeWidth="2.5" />
    <circle cx="96" cy="60" r="8" stroke="currentColor" strokeWidth="2.5" />
    <circle cx="60" cy="24" r="7" stroke="currentColor" strokeWidth="2.5" />
    <circle cx="60" cy="96" r="7" stroke="currentColor" strokeWidth="2.5" />
    <rect
      x="44"
      y="44"
      width="32"
      height="32"
      rx="8"
      stroke="currentColor"
      strokeWidth="2.5"
    />
    <circle cx="52" cy="56" r="2.5" fill="currentColor" />
    <circle cx="68" cy="56" r="2.5" fill="currentColor" />
    <path
      d="M52 66c2.5 3 7.5 3 10 0"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M60 38v6M78 60h-6M60 82v-6M42 60h6"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      opacity="0.55"
    />
  </svg>
);
